import { i18n } from 'i18n';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export interface ConfirmationOptions {
  // NOTE: Moving between various node versions this prop is sometimes flaged as an issue.
  // eslint-disable-next-line react/no-unused-prop-types
  catchOnCancel?: boolean;
  variant: 'danger' | 'info';
  title?: string;
  description?: string;
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
  onExited: () => void;
}

export const ConfirmationDialog = ({
  open,
  title,
  variant,
  description,
  onSubmit,
  onClose,
  onExited,
}: ConfirmationDialogProps) => (
  <Dialog
    open={open}
    slotProps={{
      transition: {
        onExit: onExited,
      },
    }}
  >
    {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
    {description && (
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
    )}
    <DialogActions>
      {variant === 'danger' && (
        <>
          <Button color="secondary" variant="text" onClick={onClose} autoFocus>
            {i18n._('CANCEL')}
          </Button>
          <Button color="secondary" variant="text" onClick={onSubmit}>
            {i18n._('YES')}
          </Button>
        </>
      )}

      {variant === 'info' && (
        <>
          <Button color="secondary" variant="text" onClick={onClose}>
            {i18n._('CANCEL')}
          </Button>
          <Button color="secondary" variant="text" onClick={onSubmit} autoFocus>
            {i18n._('OK')}
          </Button>
        </>
      )}
    </DialogActions>
  </Dialog>
);
